import { computed, DestroyRef, inject, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { useBeforeUnload } from '@rp/utils';
import { isEqual } from 'lodash';

import { IHaveChanges } from '../../models';

type AbstractConstructor<T = object> = abstract new (...args: any[]) => T;

export function WithConfirmOnLeave<TBase extends AbstractConstructor>(Base: TBase) {
  abstract class Mixin extends Base implements IHaveChanges {
    initFormState = signal<object | null>(null);
    abstract form: FormGroup;

    readonly _destroyRef = inject(DestroyRef);

    constructor(...args: any[]) {
      super(...args);

      useBeforeUnload(
        computed(() => !this.haveChanges()),
        this._destroyRef,
      );
    }

    saveInitFormState(): void {
      this.initFormState.set(this.form.getRawValue());
    }

    resetInitFormState(): void {
      this.initFormState.set(null);
    }

    haveChanges(): boolean {
      return this.initFormState() && !isEqual(this.initFormState(), this.form.getRawValue());
    }
  }

  return Mixin;
}
